module.exports = "/wwwroot/img/measurement_station_info_block.png?ver=e8856dc1";